import React from 'react';
import { Move, RotateCcw, Scale } from 'lucide-react';
import NumericTransformPanel from './NumericTransformPanel';

export default function TransformToolbar({ 
  transformMode, 
  onModeChange,
  onSnappingToggle,
  onConstraintsToggle,
  isSnappingEnabled = false,
  constraints = { x: true, y: true, z: true },
  selectedObject,
  selectedModelId,
  onTransformChange,
  currentTransformValues,
  initialTransform = null,
  scaleLimits = { min: 0.1, max: 3.0 },
  positionLimits = { x: { min: -5, max: 5 }, y: { min: -3, max: 5 }, z: { min: -5, max: 5 } }
}) {
  console.log(`[TransformToolbar] Render with initialTransform:`, initialTransform);
  
  const handleModeChange = (mode) => {
    onModeChange(mode);
  };

  const handleAxisToggle = (axis) => {
    onConstraintsToggle(axis);
  };

  const buttonStyles = {
    base: 'w-10 h-10 rounded-lg bg-[#1a1a1a] hover:bg-[#2a2a2a] border border-[#2a2a2a] hover:border-[#3a3a3a] transition-all duration-200 flex items-center justify-center text-white',
    active: 'bg-[#3a3a3a] border-[#4a4a4a] text-white',
    disabled: 'opacity-50 cursor-not-allowed'
  };

  const getButtonStyle = (mode) => {
    if (transformMode === mode) {
      return `${buttonStyles.base} ${buttonStyles.active}`;
    }
    return buttonStyles.base;
  };

  // Only render when an object is selected
  if (!selectedModelId) {
    return null;
  }

  return (
    <div className="absolute left-3 top-3 z-40">
      {/* Numeric Transform Panel with integrated transform mode buttons */}
      <NumericTransformPanel
        selectedObject={selectedObject}
        onTransformChange={onTransformChange}
        isVisible={!!selectedObject}
        currentTransformValues={currentTransformValues}
        initialTransform={initialTransform}
        transformMode={transformMode}
        onModeChange={handleModeChange}
        scaleLimits={scaleLimits}
        positionLimits={positionLimits}
      />
    </div>
  );
}
